// @ts-strict-ignore
import React, { memo } from 'react'
import Link from 'components/Link'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import StyledLink from 'components/StyledLink'
import UserAvatar from 'components/UserAvatar'
import Video from 'components/Video'
import Button from 'components/Button'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { ProfileHireBox_BlogPostFragment$key } from '__generated__/ProfileHireBox_BlogPostFragment.graphql'
import { useTheme } from '@mui/material/styles'

interface ProfileHireBoxProps {
  blogPostFragment: ProfileHireBox_BlogPostFragment$key
}

function ProfileHireBox({ blogPostFragment }: ProfileHireBoxProps) {
  const theme = useTheme()

  const blogPost = useFragment(graphql`
    fragment ProfileHireBox_BlogPostFragment on BlogPost {
      video {
        ...Video_Video
      }
      user {
        id
        name
        canMakeOffer
        ...UserAvatarContainer_User
        video {
          ...Video_Video
        }
        profile {
          visibility
          openToOpportunities
          slug
          industry {
            name
          }
        }
      }
    }
  `, blogPostFragment)

  const userId = blogPost?.user?.id
  const profileSlug = blogPost?.user?.profile?.slug
  const industryName = blogPost?.user?.profile?.industry?.name
  const subheader = industryName ? `${industryName} Expert` : 'Flexhire Member'

  return (
    <Card raised style={{ maxWidth: 290, margin: '0 auto' }}>
      <CardHeader
        title={(
          <Link
            href={`/${profileSlug}`}
            style={{ textDecoration: 'none' }}
          >
            {blogPost?.user?.name}
          </Link>
        )}
        subheader={subheader}
        avatar={<UserAvatar userFragmentRef={blogPost?.user} />}
      />

      <CardContent style={{ padding: 0 }}>
        <div>
          {(blogPost?.video || blogPost?.user?.video) && (
            <Video videoFragmentRef={blogPost?.video || blogPost?.user?.video} iconSize="small" compact />
          )}
        </div>
      </CardContent>

      <CardActions style={{ justifyContent: 'center' }}>
        {blogPost?.user?.profile?.visibility === 'visibility_public' && (
          <Button
            component={StyledLink}
            href={`/${profileSlug}`}
            color="secondary"
            style={{ paddingBottom: theme.spacing(1) }}
            fullWidth
          >
            Profile
          </Button>
        )}

        {blogPost?.user?.profile?.openToOpportunities && blogPost?.user?.canMakeOffer && (
          <Button
            component={StyledLink}
            href={`/make_offer?member=${userId}`}
            color="primary"
            style={{ paddingBottom: theme.spacing(1) }}
            fullWidth
          >
            Hire
          </Button>
        )}
      </CardActions>
    </Card>
  )
}

export default memo(ProfileHireBox)
